import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ThemeType } from "theme";
interface InitialState {
  isMiniSidenav: boolean;
  isHiddenSidenav: boolean;
  isMiniWindow: boolean;
  themeType: ThemeType;
}
const initialState: InitialState = {
  isMiniSidenav: false,
  isHiddenSidenav: false,
  isMiniWindow: false,
  themeType: ThemeType.LIGHT,
};

const themesSlice = createSlice({
  name: "themesSlice",
  initialState,
  reducers: {
    changeTheme: (state) => {
      if (state.themeType === ThemeType.LIGHT) {
        state.themeType = ThemeType.DARK;
      } else {
        state.themeType = ThemeType.LIGHT;
      }
    },
    changeIsMiniSidenav: (state, action: PayloadAction<boolean>) => {
      state.isMiniSidenav = action.payload;
    },
    changeIsHiddenSidenav: (state, action: PayloadAction<boolean>) => {
      state.isHiddenSidenav = action.payload;
    },
    changeIsMiniWindow: (state, action: PayloadAction<boolean>) => {
      state.isMiniWindow = action.payload;
    },
  },
});

export const {
  changeTheme,
  changeIsMiniSidenav,
  changeIsHiddenSidenav,
  changeIsMiniWindow,
} = themesSlice.actions;

export default themesSlice.reducer;
